import { render, staticRenderFns } from "./awardsList.vue?vue&type=template&id=c31095cc&scoped=true"
import script from "./awardsList.vue?vue&type=script&lang=js"
export * from "./awardsList.vue?vue&type=script&lang=js"
import style0 from "./awardsList.vue?vue&type=style&index=0&id=c31095cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31095cc",
  null
  
)

export default component.exports